"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = void 0;
// TODO: remove in 5.x
const compose = function () {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return fns.length === 0 ? x => x : fns.reduce((accFn, fn) => function () {
    return accFn(fn(...arguments));
  });
};
exports.compose = compose;